angular.module("persons_treatments")

    .controller("PersonsTreatmentsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("PERSONS_TREATMENTS_WRITE");

            $rootScope.title = $filter('translate')('persons_treatments.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('persons_treatments.title') }
            ];

            $scope.gridOptionsPersonsTreatments = {
                pdfTitle: $filter('translate')('persons_treatments.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [50, 100],
                paginationPageSize: 50,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    { name: 'name', displayName: $filter('translate')('persons_treatments.name'), enableFiltering: true, enableHiding: false },
                    { name: 'male_description', displayName: $filter('translate')('persons_treatments.male_description'), enableFiltering: true, enableHiding: false },
                    { name: 'female_description', displayName: $filter('translate')('persons_treatments.female_description'), enableFiltering: true, enableHiding: false },
                    { name: 'person_default', displayName: $filter('translate')('persons_treatments.person_default'), enableFiltering: false, enableHiding: false, cellTemplate: gridService.yesNoTemplate('person_default') },
                    { name: 'position_default', displayName: $filter('translate')('persons_treatments.position_default'), enableFiltering: false, enableHiding: false, cellTemplate: gridService.yesNoTemplate('position_default') },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('persons_treatments.button_edit'), action: 'ui-sref="persons_treatments.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('persons_treatments.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    options.is_list = true;
                    return Restangular.all('PersonsTreatments').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("persons_treatments.edit", { id: rowEntity.id });
            }


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('persons_treatments.button_delete'),
                    message: $filter('translate')('persons_treatments.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('PersonsTreatments', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('persons_treatments.deleted_success'));
                            $scope.gridOptionsPersonsTreatments.gridApi.core.raise.itemDeleted($scope);

                        });
                    }
                });

            };

        }])

;
